import ROUTES from '../consts/paths'
import { prefersHomeDashboardRole, prefersReportsLandingRole } from './roleHelpers'

export const getPriorityBaseRoute = (
  roleName: string | undefined,
  validPaths: string[]
): string | undefined => {
  if (!validPaths.length) return undefined

  if (prefersReportsLandingRole(roleName) && validPaths.includes(ROUTES.REPORTS)) {
    return ROUTES.REPORTS
  }

  if (prefersHomeDashboardRole(roleName) && validPaths.includes(ROUTES.ADMIN_VIEWER_DASHBOARD)) {
    return ROUTES.ADMIN_VIEWER_DASHBOARD
  }

  return validPaths[0]
}
